import { USER_PERMISSIONS } from 'dyl-components';
import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import RestrictedView from 'shared/RestrictedView';

const AddTemplateHeader = ({ onOpenAddTemplateSection }) => (
    <Grid verticalAlign='middle'>
        <Grid.Column width={6}>
            Script Management
        </Grid.Column>
        <Grid.Column width={4} textAlign='right' floated='right'>
        <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.LIBRARY_ADD}>
        <Button onClick={onOpenAddTemplateSection} size='tiny' basic inverted color='white'>Add Script</Button>
        </RestrictedView>
        </Grid.Column>
    </Grid>
)

export default AddTemplateHeader;
